import type React from "react";
import {Box, Tooltip} from "@mui/material";
import type {PtV2TermMixItem} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Classes.ts";
import {termMixShares} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Calc.ts";
import {
    formatEur,
    formatRatio,
    MISSING,
    termColor,
    termDays,
} from "~/experiments/pages/payment-terms-v2/paymentTermsV2Format.ts";

/** A supplier's spend split by ERP term as one thin stacked bar; the tooltip lists the terms. */
export const PtV2TermMixBar: React.FC<{mix: PtV2TermMixItem[]}> = ({mix}) => {
    const items = termMixShares(mix);
    if (items.length === 0) return <span className="ptv2-faint">{MISSING}</span>;
    // The tooltip is portalled outside the page, so it is styled inline.
    const tip = <div>
        {items.map((m, i) => <div key={`${m.termCode}-${i}`}>
            <Box component="i" sx={{display: 'inline-block', width: 8, height: 8, borderRadius: '2px', mr: 0.75,
                background: termColor(m.netDays ?? termDays(m.termCode))}}/>
            <b>{m.termCode || 'Not set'}</b> {formatRatio(m.share, 0)} · {formatEur(m.spend)}
        </div>)}
    </div>;
    return <Tooltip title={tip} placement="top" arrow>
        <span className="ptv2-mix">
            <span className="ptv2-mix-bar" aria-label={items.map(m => `${m.termCode || 'Not set'} ${formatRatio(m.share, 0)}`).join(', ')}>
                {items.map((m, i) => <span key={`${m.termCode}-${i}`}
                                           style={{width: `${m.share * 100}%`, background: termColor(m.netDays ?? termDays(m.termCode))}}/>)}
            </span>
            {items.length > 1 && <span className="ptv2-faint ptv2-num">({items.length} terms)</span>}
        </span>
    </Tooltip>;
};
